import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Globe, Instagram, X } from "lucide-react";
import { useContent } from "../context/ContentContext";

export default function JoinModal({ open, onOpenChange }) {
    const { content } = useContent();
    const j = content.join;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-testid="join-modal"
                className="bg-meraki-bg border-meraki-gold/30 rounded-none max-w-lg p-0 overflow-hidden"
            >
                <DialogTitle className="sr-only">Join Meraki Riders</DialogTitle>
                <DialogDescription className="sr-only">
                    Choose how to join the Meraki Riders community — via the official webapp or Instagram.
                </DialogDescription>
                <div className="p-8 md:p-10">
                    <div className="flex items-start justify-between mb-8">
                        <div>
                            <div className="text-[10px] uppercase tracking-[0.4em] text-meraki-gold mb-3">Ride With Us</div>
                            <h3 className="font-display text-3xl md:text-4xl uppercase text-meraki-text leading-tight">
                                {j.heading_line1}<br /><span className="text-meraki-gold">{j.heading_line2}</span>
                            </h3>
                        </div>
                        <button
                            data-testid="join-modal-close"
                            onClick={() => onOpenChange(false)}
                            className="text-meraki-muted hover:text-meraki-gold transition-colors"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>

                    <p className="text-meraki-muted text-sm mb-8 leading-relaxed whitespace-pre-line">{j.paragraph}</p>

                    <div className="space-y-4">
                        <a
                            href={j.option1_url}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="join-webapp-btn"
                            className="group block border border-meraki-gold/40 hover:border-meraki-gold p-6 transition-all hover:bg-meraki-gold/5"
                        >
                            <div className="flex items-start gap-4">
                                <div className="w-12 h-12 border border-meraki-gold/40 group-hover:border-meraki-gold flex items-center justify-center transition-colors">
                                    <Globe className="w-5 h-5 text-meraki-gold" />
                                </div>
                                <div className="flex-1">
                                    <div className="text-[10px] uppercase tracking-[0.3em] text-meraki-gold mb-1">Option 01</div>
                                    <div className="font-heading uppercase tracking-wider text-meraki-text text-lg">{j.option1_label}</div>
                                    <div className="text-xs text-meraki-muted mt-2">{j.option1_desc}</div>
                                </div>
                                <span className="text-meraki-gold text-2xl group-hover:translate-x-1 transition-transform">→</span>
                            </div>
                        </a>

                        <a
                            href={j.option2_url}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="join-instagram-btn"
                            className="group block border border-meraki-gold/40 hover:border-meraki-gold p-6 transition-all hover:bg-meraki-gold/5"
                        >
                            <div className="flex items-start gap-4">
                                <div className="w-12 h-12 border border-meraki-gold/40 group-hover:border-meraki-gold flex items-center justify-center transition-colors">
                                    <Instagram className="w-5 h-5 text-meraki-gold" />
                                </div>
                                <div className="flex-1">
                                    <div className="text-[10px] uppercase tracking-[0.3em] text-meraki-gold mb-1">Option 02</div>
                                    <div className="font-heading uppercase tracking-wider text-meraki-text text-lg">{j.option2_label}</div>
                                    <div className="text-xs text-meraki-muted mt-2">{j.option2_desc}</div>
                                </div>
                                <span className="text-meraki-gold text-2xl group-hover:translate-x-1 transition-transform">→</span>
                            </div>
                        </a>
                    </div>

                    <div className="mt-8 pt-6 border-t border-meraki-gold/15 text-[10px] uppercase tracking-[0.3em] text-meraki-muted text-center">
                        Reminder · Stay active · Ride once a quarter
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
